module.exports = __webpack_public_path__ + "img/orgDetail_2_small.4ad0710c.png";